import Modal from "react-modal/lib/components/Modal";
import { useContext, useState } from "react";
import { ContextRegisterCollaborator } from "../context";
import Switch from "@mui/material/Switch";
import "./style.css";

import { IndexHooks } from "./hook";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { LibString } from "../../../../util/libString";
import { BtnSearch } from "../../../button/button-search";
import closeImg from "../../../../assets/close.png";

export const ModalFilterCollaborator = () => {
	const { openModalFilterCollaborator, isOpenModalFilterCollaborator, setPage } =
		useContext(ContextRegisterCollaborator);
	const {
		//
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		Controller,
		control,
	} = IndexHooks();
	const { capitalizeFirstLetter } = LibString();

	const parameters = [
		{ id: "nome", label: "Nome", value: "nome" },
		{ id: "cargo", label: "Cargo", value: "cargo" },
	];

	const handleRadioOnClick = (e) => {
		setFocus("paramValue");
	};

	const handle = () => {
		setPage(1);
	};

	return (
		<Modal
			isOpen={isOpenModalFilterCollaborator}
			onRequestClose={openModalFilterCollaborator}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<div className="container-filter-client">
				<form action="" onSubmit={handleSubmit(handleOnSubmit)}>
					<header>
						<h2 className="title">Colaborador</h2>
						<h6 className="text-xs border-botton mt-3 text-secondary">Pesquisar por..</h6>
						<button type="button" onClick={openModalFilterCollaborator} className="react-modal-close">
							<img src={closeImg} alt="" />
						</button>
					</header>
					<div className="field-group">
						<div className="row">
							<div className=" container-radio d-flex align-items-center flex-wrap col-10">
								{parameters.map((option) => (
									<div key={option.id} className="radio col-6 col-sm-4 col-lg-3">
										<input //
											type="radio"
											id={option.id}
											value={option.value}
											onClick={(event) => handleRadioOnClick()}
											{...register("param")}
											style={{ display: "none" }}
										/>

										<label htmlFor={option.id}>
											<span
												htmlFor={option.id}
												style={{
													marginRight: "0.5rem",
												}}
											>
												<FontAwesomeIcon
													icon={paramSelected === option.value ? faCheckSquare : faSquare}
													className="custom-checkbox"
												/>
											</span>
											{option.label}
										</label>
									</div>
								))}
							</div>
							{errors.param && <p className="errors">{errors.param.message}</p>}

							<div className="container-switch col-2 flex-wrap">
								<div className="check-input d-flex align-items-center justify-content-end">
									<Controller
										name="active"
										control={control}
										defaultValue={true}
										render={({ field }) => (
											<Switch
												checked={field.value}
												onChange={(e) => field.onChange(e.target.checked)}
												inputProps={{
													"aria-label": "Clientes Ativos",
												}}
											/>
										)}
									/>
									<label htmlFor="active">Ativo</label>
									{errors.active && <p className="errors">{errors.active.message}</p>}
								</div>
							</div>
						</div>

						<div className="input-box mt-3">
							<label htmlFor="paramValue">{capitalizeFirstLetter(paramSelected)}</label>
							<input //
								id="paramValue"
								{...register("paramValue")}
								type="text"
								onFocus={(e) => e.target.select()}
								autoComplete="off"
								autoFocus
							/>
							{errors.paramValue && <p className="errors">{errors.paramValue.message}</p>}
						</div>
					</div>
					<footer>
						<BtnSearch isSubmitting={isSubmitting} />
					</footer>
				</form>
			</div>
		</Modal>
	);
};
